import * as req from 'api/actions';
import * as c from './constant';

export const getEndorsingOfficesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_ENDORSING_OFFICES,
    '/api/v1/bpls/administrator/endorsing_offices',
    payload,
    callback
  );

export const getSingleEndorsingOffices = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ENDORSING_OFFICES,
    `/api/v1/bpls/administrator/endorsing_offices/${id}`,
    payload,
    callback
  );

export const createEndorsingOffices = (payload, callback) =>
  req.create(
    c.CREATE_ENDORSING_OFFICES,
    '/api/v1/bpls/administrator/endorsing_offices',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateEndorsingOffices = (id, payload, callback) =>
  req.update(
    c.UPDATE_ENDORSING_OFFICES,
    `/api/v1/bpls/administrator/endorsing_offices/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getAdministratorList = (
    payload = { sort_by: 'asc' },
    callback
  ) =>
    req.list(
      c.GET_ADMINISTRATOR,
      '/api/v1/administrators/administrators',
      payload,
      callback
    );

export const attachUsers = (id, payload, callback) =>
  req.create(
    c.ATTACH_ADMINISTRATOR,
    `/api/v1/bpls/administrator/endorsing_office_users/${id}/attach_users`,
    payload,
    callback
  );

export const detachAdministrator = (id, payload, callback) =>
  req.create(
    c.DETACH_ADMINISTRATOR,
    `/api/v1/bpls/administrator/endorsing_office_users/${id}/detach_users`,
    payload,
    callback
  );

export const deleteEndorsingOffices = (id, payload, callback) =>
  req.remove(
    c.DELETE_ENDORSING_OFFICES,
  `/api/v1/bpls/administrator/endorsing_offices/${id}`,
    payload,
    callback
  );